import { AcceptedProps } from '../../../interface/accepted-props';

export const isInsideTable = (props: AcceptedProps): boolean => {
  return props.tableId !== '' && typeof props.tableColumnRowIndex === 'number';
};